import { t } from 'i18next';
import { ObjectSchema } from 'yup';
import Yup from '../../../services/common/validation';
import { PreviousAddressFormModel_MX } from './formModel';

export const getValidationSchema = (): ObjectSchema<Partial<PreviousAddressFormModel_MX>> => {
  return Yup.object({
    addressLine1: Yup.string()
      .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers'))
      .required(t('validation:required')),
    addressLine2: Yup.string()
      .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers'))
      .notRequired(),
    addressLine3: Yup.string()
      .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers'))
      .notRequired(),
    eirCode: Yup.string().eirCode(t('validation:invalidEircode')).required(t('validation:required')),
    town: Yup.string()
      .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers'))
      .required(t('validation:required')),
    county: Yup.string().required(t('validation:required')),
    residentialStatus: Yup.string().required(t('validation:required')),
    timeAtAddressFrom: Yup.string().required(t('validation:required')),
    timeAtAddressTo: Yup.string().required(t('validation:required')),
  });
};
